// LIBRARIES
import { BORDER_RADIUS, DEVICE_TYPE, MARGIN } from "constants/variables";
import styled, { css } from "styled-components";

// Define the styled components
export const ParentContainer = styled.div`
  margin: ${MARGIN.max180} 0;
  padding: 0 ${MARGIN.fix32};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding-left: ${MARGIN.fix24};
    padding-right: ${MARGIN.fix24};
  }
`;

export const Title = styled.h1`
  margin: 0;
  width: 369px;
  text-align: center;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 326px;
  }
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: ${MARGIN.fix24};
  height: 472px;
  max-width: 1416px;
  width: 100%;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, auto);
    max-width: 472px;
    min-height: 1616px;
    gap: ${MARGIN.max12};
    > *:nth-child(1),
    > *:nth-child(2) {
      grid-row: span 1;
      height: auto;
    }
  }
`;

export const CardContainer = styled.div<{
  colSpan: number;
  rowSpan: number;
  isImage?: boolean;
}>`
  grid-column: span ${({ colSpan }) => colSpan};
  grid-row: span ${({ rowSpan }) => rowSpan};
  border-radius: ${BORDER_RADIUS.radius21};
  overflow: hidden;
  background-color: #77191a;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${MARGIN.max40};
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardTitle = styled.h2`
  margin: 0;
  text-align: center;
  max-width: 346px;
`;

export const CardContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.fix24};
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max4};
`;

export const CardIllustration = styled.img`
  position: absolute;
  bottom: -107px;
  right: -107px;
  width: 255px;
  height: 255px;
  transform: rotate(90deg);
`;

// Define the card types
type CardProps = {
  type: "image" | "title" | "content";
  content: any;
  colSpan: number;
  rowSpan: number;
};

export const SectionIllustration = styled.img`
  position: absolute;
  top: -168px;
  right: -168px;
  width: 400px;
  height: 400px;
`;

export const SectionSecondIllustration = styled.img`
  position: absolute;
  left: -160px;
  height: 472px;
`;
